import type { ReactElement } from 'react';

import { AcornSharedTrackingProvider } from '@web-platform/shared-acorn-tracking/src/AcornSharedTracking/AcornSharedTracking';
import { BananaSharedTrackingProvider } from '@web-platform/shared-banana-tracking/src/BananaSharedTracking/BananaSharedTracking';

export const ConditionalTrackingProvider = ({
  children,
  isAcorn,
}: {
  children: ReactElement;
  isAcorn: boolean;
}) =>
  isAcorn ? (
    <AcornSharedTrackingProvider>{children}</AcornSharedTrackingProvider>
  ) : (
    <BananaSharedTrackingProvider>{children}</BananaSharedTrackingProvider>
  );
